import { action, observable, runInAction } from 'mobx';
import BaseLoginStore from './BaseLoginStore';
import RootStore from './RootStore';

interface SmsInitiateLoginCredentials {
  phoneNumber: string;
}

interface SmsLoginCredentials {
  confirmationCode: string;
}

class SmsLoginStore extends BaseLoginStore {
  @observable accessor loginInitiated: boolean = false;
  @observable accessor smsInitiateLoginCredentials: SmsInitiateLoginCredentials = {
    phoneNumber: '',
  };
  @observable accessor smsLoginCredentials: SmsLoginCredentials = {
    confirmationCode: '',
  };
  @observable accessor countdownTime: number = 0;
  @observable accessor phoneNumber: string = '';
  @observable accessor phoneNumberError: string = '';
  @observable accessor confirmationCodeError: string = '';

  constructor(rootStore: RootStore) {
    super(rootStore);
  }

  @action.bound
  public setPhoneNumber(number: string): void {
    this.phoneNumberError = '';
    this.smsInitiateLoginCredentials.phoneNumber = number;
  }

  @action.bound
  public setConfirmationCode(code: string): void {
    this.smsLoginCredentials.confirmationCode = code;
  }

  @action.bound
  public resetConfirmationCodeInvalid(): void {
    this.confirmationCodeError = '';
  }

  @action.bound
  public setCountdownTime(seconds: number): void {
    this.countdownTime = seconds;
  }

  public initiateLogin = async (recaptchaToken: string | null | undefined): Promise<void> => {
    runInAction(() => {
      this.loginInitiated = false;
      this.confirmationCodeError = '';
      this.smsLoginCredentials.confirmationCode = '';
    });
    this.uiStore.hideNotices();
    const response = await this.loginWithoutMainFlow('/sms/auth', { ...this.smsInitiateLoginCredentials, captchaToken: recaptchaToken });

    if (response !== null) {
      runInAction(() => {
        this.phoneNumber = response.notice?.message || '';
        this.loginInitiated = true;
        this.countdownTime = 60;
      });
    } else {
      const noticeMessages = this.uiStore.notices.map((notice) => notice.message);
      if (noticeMessages.includes('smsauth.invalidNumber.super')) {
        runInAction(() => {
          this.phoneNumberError = 'smsauth.invalidNumber.super';
        });
      }
    }
  };

  public handleLogin = async (recaptchaToken: string | null | undefined): Promise<void> => {
    const response = await this.handleLoginTemplate(
      '/sms/auth/finish',
      {
        ...this.smsLoginCredentials,
        captchaToken: recaptchaToken,
        rememberMe: this.rememberMeStore.rememberMe,
      },
      false,
    );

    if (response === null) {
      const noticeMessages = this.uiStore.notices.map((notice) => notice.message);
      if (noticeMessages.includes('smsauth.invalidConfirmationCode')) {
        this.uiStore.hideNotices();
        runInAction(() => {
          this.confirmationCodeError = 'smsauth.invalidConfirmationCode';
        });
      }
    }
  };
}

export default SmsLoginStore;
